import React, { useState, useMemo } from 'react';
import CategoryBadge from '../CategoryBadge';
import EntryDetails from '../application/timetable/entries/EntryDetails';
import { getCategoriesForView } from '../../lib/clearance.utils';
import { LIVE_VIEW_TYPE, POST_VIEW_TYPE } from '../../constants/clearance';

const TimetableEntryPreview = ({ badges, onClick }) => (
    <li className="ckp-timetable-entry-container" onClick={onClick} style={{ cursor: 'pointer' }}>
        <div className="ckp-timetable-entry-content">
            <span className="ckp-timetable-entry-artist u-truncate">Artist Name</span>
            <span className="ckp-timetable-entry-hour">14:55 - 15:55</span>
            <div className="ckp-timetable-entry-states">
                {badges?.length ? badges : <span className="ckp-no-categories">No categories to display</span>}
            </div>
        </div>
    </li>
);

const generatePreviewData = (categories, viewType, mode) => {
    const badges = [];
    const clearing = { partnerId: 'preview' };

    const addEntry = (category, label, key) => {
        badges.push(
            <CategoryBadge
                key={key}
                category={category.label}
                label={label.label}
                color={label.color}
                untilDate={label.untilDate}
                isLiveView={viewType === LIVE_VIEW_TYPE}
            />
        );
        clearing[key] = {
            category: { label: category.label },
            label: { label: label.label, color: label.color },
            untilDate: label.untilDate
        };
    };

    if (mode === 'details') {
        const category = categories[0];
        if (category?.visibleInViews?.includes(viewType)) {
            category.labels?.forEach((label, index) => {
                addEntry(category, label, `${category.id}-${index}`);
            });
        }
    } else {
        getCategoriesForView(categories, viewType).forEach((category) => {
            const visibleLabels = category.labels?.filter((l) => l.label?.toLowerCase() !== 'hidden');
            if (!visibleLabels?.length) return;

            const randomLabel = visibleLabels[Math.floor(Math.random() * visibleLabels.length)];
            addEntry(category, randomLabel, category.id);
        });
    }

    return { badges, clearing };
};

const CategoryPreview = ({ categories = [], mode = 'overview' }) => {
    const [activeView, setActiveView] = useState(null);
    const categoriesArray = Array.isArray(categories) ? categories : [categories];

    const { liveData, postData } = useMemo(
        () => ({
            liveData: generatePreviewData(categoriesArray, LIVE_VIEW_TYPE, mode),
            postData: generatePreviewData(categoriesArray, POST_VIEW_TYPE, mode)
        }),
        [categoriesArray, mode]
    );

    const isDetailsMode = mode === 'details';
    const firstCategory = categoriesArray[0];
    const shouldShowLive = !isDetailsMode || firstCategory?.visibleInViews?.includes(LIVE_VIEW_TYPE);
    const shouldShowPost = !isDetailsMode || firstCategory?.visibleInViews?.includes(POST_VIEW_TYPE);

    const mockEntry = {
        id: 'preview-entry',
        artistName: 'Artist Name',
        stageName: 'Main Stage',
        stageDate: Date.now(),
        startHour: 53700000,
        endHour: 57300000,
        clearing: activeView === 'live' ? liveData.clearing : postData.clearing
    };

    return (
        <div className="ckp-preview-section">
            {shouldShowLive && (
                <div className="ckp-preview-view">
                    <h3>Live View Example</h3>
                    <div className="card">
                        <TimetableEntryPreview badges={liveData.badges} onClick={() => setActiveView('live')} />
                    </div>
                </div>
            )}
            {shouldShowPost && (
                <div className="ckp-preview-view">
                    <h3>Post Event View Example</h3>
                    <div className="card">
                        <TimetableEntryPreview badges={postData.badges} onClick={() => setActiveView('post')} />
                    </div>
                </div>
            )}
            {activeView && (
                <EntryDetails open onClose={() => setActiveView(null)} entry={mockEntry} selectedPartner="preview" />
            )}
        </div>
    );
};

export default CategoryPreview;
